export const ESCAPE = 'Escape'
export const ENTER = 'Enter'
export const HOME = 'Home'
export const END = 'End'

export const ARROW_DOWN = 'ArrowDown'
export const ARROW_UP = 'ArrowUp'
